<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<v-btn
									color="red"
									class="px-0"
									height="auto"
									exact
									x-large
									text
									:to="{name: `${locationName}-hub`}"
								>
									รวมโครงการ{{ location }}
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span v-if="params.category === 'singlehome'">
									บ้านเดี่ยว
								</span>
								<span v-else-if="params.category === 'townhome'">
									ทาวน์โฮม
								</span>
								<span v-else-if="params.category === 'condo'">
									คอนโด
								</span>
								<span v-else-if="params.category === 'shophouse'">
									อาคารพาณิชย์
								</span>
							</div>
							<div class="search-filter">
								<h1>
									รวมโครงการ{{ location }}
								</h1>

								<div class="pl-3 pr-5">
									<h2 v-if="params.category === 'singlehome'">
										บ้านเดี่ยว
									</h2>
									<h2 v-else-if="params.category === 'townhome'">
										ทาวน์โฮม
									</h2>
									<h2 v-else-if="params.category === 'condo'">
										คอนโด
									</h2>
									<h2 v-else-if="params.category === 'shophouse'">
										อาคารพาณิชย์
									</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="d-flex">
							<div class="px-4">
								<img
									:src="`/images/2.0/icon/${params.category}_i.png`"
									width="64"
								>
							</div>
							<div class="py-4">
								<template v-if="content === 'singlehome'">
									<h1 class="red--text">
										รวมอสังหาฯ ซื้อ ขาย บ้านเดี่ยวชลบุรี บ้านเดี่ยวมือสองชลบุรี ราคาถูก 2565
									</h1>
									<p class="mt-4">
										แนะนำโครงการบ้านเดี่ยวชลบุรี ทั้งซื้อและขายบ้านเดี่ยวชลบุรี ในช่วงราคาที่คุณต้องการไม่ว่าจะเป็นราคาไม่เกิน 1.5 ล้าน ไปจนถึงราคาสูงถึง 50 ล้านบาท ในทำเลยอดนิยมของจังหวัดชลบุรี เช่น บ้านเดี่ยวเมืองชลบุรี บ้านเดี่ยวศรีราชา บ้านเดี่ยวบ่อวิน บ้านเดี่ยวพัทยา บ้านเดี่ยวชลบุรี-บางแสน เป็นต้น หรือจะฝากประกาศขายบ้านเดี่ยวมือสองชลบุรี หรือบ้านเดี่ยวมือสองชลบุรีเจ้าของขายเอง เราพร้อมดูแลจนกว่าจะปิดการขายได้เลย
									</p>
								</template>

								<template v-else-if="content === 'townhome'">
									<h1 class="red--text">
										รวมประกาศ ซื้อ ขาย อสังหาฯ ทาวน์โฮมชลบุรี ทาวน์เฮ้าส์ชลบุรี มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										รวมประกาศซื้อ-ขายทาวน์โฮมชลบุรี ทาวน์เฮ้าส์มือสองชลบุรี ไม่ว่าจะเป็นพื้นที่ใดหรือทาวร์โฮมชลบุรีที่มีราคาเริ่มต้นตั้งแต่ล้านต้นๆ ไปจนถึงราคามากถึง 20 ล้านบาทขึ้นไป ไม่ว่าจะในพื้นที่ใดของชลบุรีก็ตามก็สามารถค้นหาที่พักอาศัยที่ต้องการได้อย่างง่ายดายที่ THE BEST PROPERTY พร้อมกับบริการโปรแกรมคำนวณสินเชื่อให้สามารถประเมินงบค่าใช้จ่ายและวางแผนในการขอสินเชื่อได้อย่างสะดวกสบายมากขึ้น
									</p>
								</template>

								<template v-else-if="content === 'condo'">
									<h1 class="red--text">
										รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดชลบุรี คอนโดมิเนียมชลบุรี มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										แนะนำคอนโดชลบุรี ทั้งโซนคอนโดศรีราชา คอนโดเมืองชลบุรี คอนโดใกล้เซ็นทรัลชลบุรี ขายคอนโดพัทยา เริ่มตั้งแต่คอนโดราคาล้านต้นๆ ไปจนถึงราคาไม่เกิน 20 ล้านบาท เริ่มต้นตั้งแต่แบบ 1 ห้องนอน/ 2 ห้องนอน/ 3 ห้องนอน ให้คุณค้นหาคอนโดมือสองชลบุรี ‘ที่ใช่’ เจอได้ในทุกทำเล ทั้งแบบพร้อมอยู่ และห้องเปล่า ซึ่งคุณสามารถเสริมความมั่นใจได้ด้วยการใช้โปรแกรมคำนวณสินเชื่อที่เรามี เพื่อวางแผนการกู้ยืมสินเชื่อก่อนได้
									</p>
								</template>

								<template v-else-if="content === 'shophouse'">
									<h1 class="red--text">
										รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์ชลบุรี ตึกแถว มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										ชลบุรีเป็นพื้นที่ศักยภาพสูงและมีการพัฒนาอยู่ตลอด ทำให้การเช่า เซ้ง ซื้อ ขายอาคารพาณิชย์ชลบุรีเกิดขึ้นอย่างคึกคัก ไม่ว่าจะเป็นการขายตึกแถวริมถนนหรือตึกแถวทำเลค้าขายก็นับว่าน่าสนใจอย่างยิ่ง เนื่องจากจะมีการพัฒนาพื้นที่เพื่อเป็นระบบ EEC ด้วย สำหรับใครที่ต้องการเป็นเจ้าของอสังหาฯ ชลบุรี สามารถเพิ่มความมั่นใจด้วยการใช้โปรแกรมคำนวณสินเชื่อของเราเพื่อวางแผนการขอสินเชื่อก่อนได้เลย
									</p>
								</template>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 py-8 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'singlehome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'townhome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'condo'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'shophouse'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="px-6 py-0">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<div
							v-if="area"
							class="text-center red--text mt-n8 pb-4"
							style="position: relative;"
						>
							<b>เลือกทำเล</b>
						</div>
						<v-slide-group
							v-model="areaSelected"
							center-active
							show-arrows
						>
							<template #next>
								<v-icon color="rgb(237,28,36)">
									$next
								</v-icon>
							</template>
							<template #prev>
								<v-icon color="rgb(237,28,36)">
									$prev
								</v-icon>
							</template>

							<v-slide-item
								v-for="(a, i) in area"
								:key="`${locationName}-${i}`"
								:value="a.value"
							>
								<v-btn
									class="area mr-2 pa-2"
									elevation="0"
									text
									tile
									:to="a.path"
								>
									{{ a.text }}
								</v-btn>
							</v-slide-item>
						</v-slide-group>

						<v-row class="mt-3">
							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-end pl-md-0 pr-md-6"
							>
								<div class="d-flex justify-center align-center">
									<img
										src="/images/2.0/icon/bed-red.png"
										width="40"
									>
									<b class="mx-3">จำนวนห้องนอน</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 1 } }"
									>
										1
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 2 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 3 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 4 } }"
									>
										4
									</v-btn>
								</div>
							</v-col>

							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-start pl-md-6 pr-md-0"
							>
								<div class="d-flex justify-center  align-center">
									<img
										src="/images/2.0/icon/money-red.png"
										width="40"
									>
									<b class="mx-3">ราคาไม่เกิน(ล้านบาท)</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 2000000 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 3000000 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 4000000 } }"
									>
										4
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 5000000 } }"
									>
										5
									</v-btn>
								</div>
							</v-col>
						</v-row>

						<div
							v-if="empty"
							class="text-center display-3"
						>
							<br><br>
							ไม่พบข้อมูล
							<br><br><br>
						</div>
						<v-row v-else>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>
									<span>อสังหา</span>
									<span
										v-if="params.category === 'singlehome'"
										class="red--text"
									>
										บ้านเดี่ยว{{ location }}
									</span>
									<span
										v-else-if="params.category === 'townhome'"
										class="red--text"
									>
										ทาวน์โฮม{{ location }}
									</span>
									<span
										v-else-if="params.category === 'condo'"
										class="red--text"
									>
										คอนโด{{ location }}
									</span>
									<span
										v-else-if="params.category === 'shophouse'"
										class="red--text"
									>
										อาคารพาณิชย์{{ location }}
									</span>
								</h2>
							</v-col>
							<v-col
								v-for="(prop, i) in loading ? parseInt(perPage) : propertyList"
								:key="prop.id || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="loading" />
								<propertyListItem
									v-else
									:id="prop.id"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<template v-if="content === 'singlehome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้านเดี่ยวชลบุรี โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>โซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี</b>
								</p>
								<p class="mb-0">
									สำหรับโซนที่นับเป็น Prime Area ของจังหวัดชลบุรีจะมีอยู่ 4 อำเภอด้วยกัน ได้แก่ ศรีราชา เกาะสีชัง พัทยา และตัวเมืองชลบุรี ซึ่งเป็นย่านที่มีดีมานด์สูงมาก เนื่องจากเป็นทำเลที่คนอยู่อาศัยเยอะจากการเป็นแหล่งงานและแหล่งท่องเที่ยวหลักของจังหวัด ราคาบ้านเดี่ยว ไม่ว่าจะเป็นบ้านเดี่ยวมือสองชลบุรีเจ้าของขายเองบ้าน เดี่ยวชั้นเดียวชลบุรี ส่วนใหญ่จะมีราคาสูงกว่าอำเภออื่นๆ โดยบ้านเดี่ยวหรือบ้านมือสองจะเริ่มต้นที่ 3-4 ล้านบาทขึ้นไป หรืออาจจะมีราคาสูงถึง 10 ล้านบาทขึ้นไปเลยทีเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>โซนสัตหีบ-บางละมุง</b>
											</p>
											<p class="mb-0">
												โซนถัดมาที่เป็นแหล่งท่องเที่ยวเชิงธรรมชาติ และเป็นที่อยู่อาศัยแนวบ้านพักตากอากาศ เพราะมีบรรยากาศดีทั้งติดภูเขา ใกล้ทะเล และเดินทางสะดวกสบาย รวมถึงยังมีพื้นที่เกษตรกรรมซึ่งตอนนี้มีการพัฒนาเป็นสนามกอล์ฟเพิ่มเติมด้วย นั่นคือช่วงอำเภอสัตหีบและบางละมุง โครงการบ้านชลบุรีในพื้นที่แถบนี้เริ่มต้นที่ 4 ล้านบาทขึ้นไป
											</p>
											<p class="mt-2 mb-0">
												<b>โซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง</b>
											</p>
											<p>
												สำหรับโซนที่มีพื้นที่เป็นทำเลด้านเกษตรกรรมเป็นส่วนใหญ่อย่างอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง ทำให้ราคาโครงการบ้านชลบุรีในโซนนี้มีราคาไม่สูงมากนัก โดยราคาบ้านในโซนนี้ก็มีหลากหลาย เริ่มตั้งแต่บ้านเดี่ยวราคาล้านต้นๆ ไปจนถึงบ้านเดี่ยวราคาไม่เกิน 2 ล้านบาท หรือราคาไม่เกิน 2.5 ล้านบาท ซึ่งจะอยู่ในโซนอำเภอพนัสนิคมและบ้านบึงที่มีแหล่งงานอุตสาหกรรมรวมอยู่ในทำเลนี้ด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกบ้านเดี่ยวชลบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้อบ้านเดี่ยวชลบุรี
								</h3>
								<p class="mt-2 mb-0">
									สำหรับวิธีการพิจารณาเลือกซื้อบ้านเดี่ยวชลบุรี นอกจากเรื่องราคาแล้ว ยังมีปัจจัยอื่นๆ ที่ช่วยทำให้คุณเลือกซื้อบ้านเดี่ยวชลบุรี ในปี 2565 ได้ตรงใจมากขึ้น ว่าแต่จะมีปัจจัยอะไรบ้างที่ควรคำนึงถึง วันนี้เราได้รวบรวมมาฝากแล้ว ดังต่อไปนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>1. โซนที่อยู่อาศัยที่ต้องการ</b>
											</p>
											<p class="mb-0">
												เนื่องจากบ้านเดี่ยวชลบุรีนั้นมีให้เลือกมากมายหลายโซน ไม่ว่าจะเป็นโซนเงียบสงบที่เน้นการอยู่อาศัยร่วมกับธรรมชาติอย่างโซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง หรือเป็นทำเลที่มีความผสมผสานทั้งเงียบสงบเหมาะกับการอยู่อาศัย และคึกคักตามสไตล์แหล่งท่องเที่ยว เช่น โซนสัตหีบ-บางละมุง ไปจนถึงโซนศักยภาพที่พัฒนาในทุกๆ ด้าน ทั้งการเป็นแหล่งรวมไลฟ์สไตล์กิน ดื่มเที่ยว แฮงค์เอาท์ เป็นแหล่งงานทั้งโรงงานอุตสาหกรรม กิจการต่างๆ เป็นที่ตั้งห้างสรรพสินค้าและสำนักงาน และมีรถโดยสารประจำทางทั้งรถตู้และรถสองแถวมากมายอย่างโซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี
											</p>
											<p class="mb-0">
												ซึ่งในแต่ละโซนก็มีเอกลักษณ์เฉพาะในพื้นที่ ก็ขึ้นอยู่ที่ว่า คุณต้องการซื้อโครงการบ้านเดี่ยวชลบุรีในทำเลที่มีไลฟ์สไตล์แบบไหน แต่ในเรื่องของทำเลก็จะสัมพันธ์กับราคาตามไปด้วย เช่น บ้านเดี่ยวศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี ก็จะมีราคาแพงมากกว่าโซนอื่น เนื่องจากมีดีมานด์สูงนั่นเอง
											</p>
											<p class="mt-2 mb-0">
												<b>2. การพัฒนาในอนาคต</b>
											</p>
											<p class="mb-0">
												เพราะจังหวัดชลบุรีมีประชากรเพิ่มขึ้นตามความเจริญที่เพิ่มเข้ามา ทำให้เป็นที่น่าสนใจของนักท่องเที่ยว นักลงทุน เพื่อรองรับประชากรและนักท่องเที่ยว จึงเกิดธุรกิจ โรงพยาบาล โรงเรียน ห้างสรรพสินค้า โรงงานอุตสาหกรรม  และแหล่งท่องเที่ยวมากมาย
											</p>
											<p class="mb-0">
												ซึ่งในปัจจุบันนี้โซนที่พัฒนาไปแล้วและมีความเจริญมากจะเป็นโซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี ที่มีแหล่งท่องเที่ยวคึกคัก ทั้ง Walking Sreet แหลมบาลีฮาย ฯลฯ แต่ในโซนสัตหีบ-บางละมุงจะเป็นแหล่งท่องเที่ยวเชิงอนุรักษ์ เชิงวัฒนธรรมที่เงียบสงบ ส่วนโซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง จะเป็นโซนเกษตรกรรมที่ทำไร่ ทำนาเป็นหลัก แต่ก็มีพื้นที่เหลือให้พัฒนาบ้านเดี่ยวต่อได้อีกมาก ก็ขึ้นอยู่กับว่า ต้องการจับจองทำเลที่เป็น Prime Area ซึ่งมีราคาสูงอยู่แล้ว หรืออยากจะซื้อบ้านเดี่ยวชลบุรีราคาถูกก็เน้นซื้อในโซนที่กำลังพัฒนาแทน
											</p>
											<p class="mt-2 mb-0">
												<b>3. สิ่งสะดวกสบายและสาธารณูปโภคหลัก</b>
											</p>
											<p>
												ใครที่ซื้อบ้านเดี่ยวชลบุรีแล้วต้องการความสะดวกสบายเป็นหลัก เช่น การเดินทาง อาหารการกิน ห้างสรรพสินค้า หรือแหล่งท่องเที่ยวยอดฮิตต่างๆ ก็แนะนำให้เลือกซื้อบ้านเดี่ยวชลบุรีในโซนที่เป็นเขตโรงงานอุตสาหกรรมและแหล่งท่องเที่ยวอย่างโซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี และโซนสัตหีบ-บางละมุงเป็นหลัก เพราะในโซนนี้จะเดินทางเข้า-ออกเมืองง่าย ไปกรุงเทพฯ สะดวก วิ่งเข้าถนนหลักอย่างสุขุมวิท แล้ววิ่งขึ้นทางพิเศษบูรพาวิถีได้ง่ายๆ ร้านอาหาร แหล่งแฮงค์เอาท์ก็มีรายล้อมตลอด 2 ข้างทาง แต่ถ้าโหยหาความสงบ อยากได้บ้านเดี่ยวชลบุรีที่มีความเป็นส่วนตัว ราคาไม่แพงมาก แต่ยังคงพัฒนาได้ต่อเนื่องอย่างการเลือกซื้อบ้านในโซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึงก็ตอบโจทย์เช่นเดียวกัน ซึ่งโซนนี้เองก็เดินทางไม่ยากวิ่งขึ้นฉะเชิงเทราเพื่อเข้ากรุงเทพฯ ได้เลย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'townhome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้าน ทาวน์เฮ้าส์ ทาวน์โฮมชลบุรี โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับการเลือกอสังหาฯ พร้อมอยู่ ไม่ว่าจะเป็นทาวน์เฮ้าส์ชลบุรีหรือทาวน์โฮมชลบุรี จะมีราคาการซื้อ-ขายที่สามารถแบ่งได้ตามโซนของพื้นที่ เพราะในชลบุรีนั้นมีการพัฒนาทำเลที่ต่างกันออกไปถึง 3 รูปแบบ โดยจะแบ่งออกเป็นโซน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>โซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี</b>
											</p>
											<p class="mb-0">
												เป็นทำเลที่ได้รับการพัฒนามาอย่างหลากหลายและครบครันอยู่ในตัว จึงเป็นโซนที่คึกคักมากที่สุด เพราะมีทั้งแหล่งท่องเที่ยว แหล่งอุตสาหกรรมและแหล่งพักอาศัย ด้วยเหตุนี้ราคาทาวน์เฮ้าส์ชลบุรีและทาวน์โฮมชลบุรีในโซนนี้จึงมีราคาสูงกว่าพื้นที่อื่นๆ อยู่บ้าง ซึ่งหากอยู่ในพื้นที่ Prime Area เช่น ใกล้ถนนสุขุมวิท ใกล้ชายทะเลหรือในตัวเมืองชลบุรีจะมีราคาค่อนข้างสูง โดยมีเรตราคาซื้อ-ขายเริ่มต้นที่ 1 ล้านบาท และสามารถมีราคาสูงได้ถึง 30-40 ล้านบาทเลยทีเดียว
											</p>
											<p class="mt-2 mb-0">
												<b>โซนสัตหีบ-บางละมุง</b>
											</p>
											<p class="mb-0">
												ทั้ง 2 อำเภอ ได้แก่ สัตหีบและบางละมุง นับเป็นโซนสำหรับการท่องเที่ยวแห่งหนึ่งของชลบุรีด้วยเช่นกัน แต่จะมีความเงียบสงบมากกว่า ไม่คึกคักแบบโซนพัทยาจึงเหมาะสำหรับการพักผ่อน ทำให้ทาวน์โฮมชลบุรีในพื้นที่ได้รับความนิยมมากขึ้นไปด้วย โดยราคาทาวน์โฮมชลบุรีจะมีราคาเริ่มต้นอยู่ที่ 1.5 ล้านบาท ไปจนถึง 20 ล้านบาทขึ้นอยู่กับทำเลและการตกแต่งพร้อมอยู่
											</p>
											<p class="mt-2 mb-0">
												<b>โซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง</b>
											</p>
											<p>
												ขณะที่พื้นที่ 2 ใน 3 ของชลบุรีเป็นพื้นที่อุตสาหกรรมและท่องเที่ยวที่ค่อนข้างคึกคัก ยังมีส่วนหนึ่งของชลบุรีที่เงียบสงบและเป็นพื้นที่เพื่อการเกษตรกรรม ทาวน์โฮมชลบุรีในแถบนี้จึงมีราคาที่จับต้องได้ แต่โดยส่วนใหญ่จะเป็นบ้านเดี่ยวเสียมากกว่า โดยจะมีราคาเริ่มต้นแต่ต่ำกว่า 1 ล้านบาท ไปจนถึง 3 ล้านบาทมักจะขึ้นอยู่กับขนาดของพื้นที่ใช้สอยภายในบ้านและทำเลที่ตั้งด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอสังหาฯ ทาวน์เฮ้าส์ ทาวน์โฮมชลบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้ออสังหาฯ ทาวน์เฮ้าส์ ทาวน์โฮมชลบุรี
								</h3>
								<p class="mt-2 mb-0">
									<b>การเลือกทาวน์โฮมชลบุรีตามทำเลการพักผ่อน</b> ในพื้นที่ชลบุรีมีสถานที่ท่องเที่ยวและพักผ่อนอยู่มากเพราะเป็นจังหวัดที่อยู่ติดทะเล ทั้งยังมีเกาะสีชังอยู่ด้วย ทำให้เหมาะสำหรับคนที่ต้องการมีบ้านพักตากอากาศขนาดไม่ใหญ่มากเอาไว้สำหรับการพักผ่อนในวันหยุด ทาวน์โฮมชลบุรีหรือทาวน์เฮ้าส์มือสองจึงเป็นตัวเลือกที่นับว่าน่าสนใจอย่างมาก โดยเฉพาะสำหรับคนที่ต้องการพักผ่อนใกล้ชายทะเล อย่างพื้นที่เมืองชลบุรี ศรีราชา พัทยา บางละมุงและสัตหีบ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mb-0">
												นอกจากนี้ ใครที่ต้องการการพักผ่อนท่ามกลางธรรมชาติที่เงียบสงบ ที่ชลบุรีก็ยังมีทำเลในลักษณะนี้ให้เลือกด้วยเช่นกัน เพราะพื้นที่อย่างอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึงนี้เป็นส่วนของพื้นที่เกษตรกรรมจึงมีการทำฟาร์มที่เปิดให้ท่องเที่ยวได้อยู่มากมาย แต่ในการเลือกทาวน์โฮมชลบุรีในพื้นที่นี้จะขยับเข้าใกล้ตัวเมืองสักหน่อย เพราะในพื้นที่ส่วนใหญ่ในโซนนี้มักจะเป็นบ้านเดี่ยวมากกว่า
											</p>
											<p class="mt-2 mb-0">
												<b>การเลือกทาวน์โฮมชลบุรีตามความสะดวกในการเดินทาง</b> หลายคนที่ต้องการบ้านพักหลังที่สองที่ยังสามารถเดินทางเชื่อมต่อเข้ากรุงเทพได้สะดวก จึงสามารถเลือกพื้นที่อย่างเมืองชลบุรี ศรีราชา บางละมุงและสัตหีบในการซื้อทาวน์โฮมชลบุรีได้ เพราะเส้นทางตามถนนสุขุมวิทซึ่งเป็นถนนหลักของจังหวัดในปัจจุบันนี้จะมีการพัฒนารถไฟฟ้าความเร็วสูงเพื่อเชื่อมต่อกรุงเทพและสนามบินทั้ง 3 ได้แก่ สนามบินดอนเมือง สนามบินสุวรรณภูมิและสนามบินอู่ตะเภา สู่พื้นที่ EEC ภายในจังหวัดชลบุรี ทำให้การเดินทางสะดวกสบายขึ้นอย่างมาก
											</p>
											<p class="mb-0">
												และหากกล่าวถึงปัจจุบันนี้ชลบุรีก็ยังสามารถเดินทางเข้ากรุงเทพฯ ได้อย่างสะดวกเพราะสามารถใช้ถนนสุขุมวิทเชื่อมต่อขึ้นทางพิเศษบูรพาวิถีได้ด้วย จึงทำให้ชลบุรีเป็นตัวเลือกที่น่าสนใจสำหรับการพักผ่อนและท่องเที่ยวอย่างมาก
											</p>
											<p class="mt-2 mb-0">
												<b>การเลือกทาวน์โฮมชลบุรีตามความสะดวกในการทำงาน</b> ในพื้นที่ชลบุรีนั้นได้มีการพัฒนาเป็นนิคมอุตสาหกรรมขนาดใหญ่อยู่มากมาย เช่น นิคมอุตสาหกรรมอมตะนคร นิคมอุตสาหกรรมปิ่นทอง หรือนิคมอุตสาหกรรมแหลมฉบัง เป็นต้น ทำให้ที่พักอาศัยอย่างทาวน์โฮมชลบุรีค่อนข้างเป็นที่นิยมอย่างมากสำหรับคนทำงาน โดยส่วนใหญ่มักจะอยู่ในพื้นที่อำเภอพานทอง ศรีราชาและเมืองชลบุรีกันเป็นจำนวนมาก เพราะเป็นย่านที่มีนิคมอุตสาหกรรมอยู่มาก ทำให้มีการพัฒนาโครงการที่อยู่อาศัยค่อนข้างมากด้วยเช่นเดียวกัน อีกทั้งยังเป็นตัวเลือกที่น่าสนใจสำหรับคนที่ทำงานในนิคมอุตสาหกรรมที่ต้องการเดินทางและใช้ชีวิตได้อย่างสะดวกมากขึ้น นอกจากนี้พื้นที่โดยรอบยังมีโรงเรียน โรงพยาบาล ตลาดและห้างสรรพสินค้าทำให้พื้นที่เหมาะสำหรับการอยู่อาศัยเป็นครอบครัวด้วยเช่นกัน
											</p>
											<p class="mt-2 mb-0">
												<b>การเลือกทาวน์โฮมชลบุรีเพื่อการลงทุน</b> เพราะชลบุรีนับเป็นทำเลศักยภาพแห่งหนึ่ง ไม่ว่าจะเป็นการท่องเที่ยวหรือการทำงานก็มีให้เลือกสรรได้หลายพื้นที่ ทำให้การซื้อทาวน์เฮ้าส์ชลบุรีเพื่อการลงทุนเป็นตัวเลือกที่น่าสนใจอย่างมาก เพราะชลบุรีมีการพัฒนาพื้นที่อย่างต่อเนื่อง โดยเฉพาะในพื้นที่อำเภอเมืองชลบุรี ศรีราชา พัทยา บางละหุงและสัตหีบ จะเป็นทำำที่น่าจับตามอง เพราะไม่ว่าจะเป็นการท่องเที่ยว นิคมอุตสาหกรรมหรือการเดินทาง ล้วนมีอยู่ในพื้นที่ทั้งหมดจึงเป็นตัวเลือกที่ดีสำหรับนักลงทุนที่ต้องการเก็งกำไรด้วยการซื้อ-ขายหรือปล่อยเช่าเป็นหลัก
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'condo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ คอนโดชลบุรี ในโซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2">
									สำหรับราคาของคอนโดชลบุรีจะขึ้นอยู่กับโซนพื้นที่ต่างๆ โดยทำเลในชลบุรีจะแบ่งออกเป็น 3 โซนหลักๆ ได้แก่ โซนพื้นที่เกษตรกรรม โรงงานอุตสาหกรรม และแหล่งท่องเที่ยว ซึ่งคอนโดชลบุรีมักจะกระจุกตัวอยู่ในโซนที่เป็นแหล่งโรงงานอุตสาหกรรม และแหล่งท่องเที่ยวเป็นหลัก ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>คอนโดชลบุรีในโซนศรีราชา-เกาะสีชัง-พัทยา-ตัวเมืองชลบุรี</b>
											</p>
											<p class="mb-0">
												จะเป็นโซนที่เรียกได้ว่า คึกคักมากที่สุด จากการเป็นเมืองท่า เมืองอุตสาหกรรม และแหล่งท่องเที่ยว ทำให้ราคาคอนโดชลบุรีในโซนนี้พุ่งสูงขึ้นอย่างต่อเนื่อง หากเป็นโซนที่อยู่ติดกับถนนสุขุมวิท ซึ่งเป็นโซนที่มีคอนโดขึ้นเยอะที่สุด เริ่มตั้งแต่ราคาไม่เกิน 1 ล้านบาท ราคาไม่เกิน 2 ล้านบาท หรือราคาไม่เกิน 3 ล้านบาท แต่ถ้าเป็นโซนหรือศรีราชาที่มีดีมานด์สูงมากๆ เช่น โซนคอนโดศรีราชาติดทะเล คอนโดพัทยา ส่วนใหญ่จะเป็นกลุ่ม Segment ราคาไม่เกิน 4 ล้านบาท -5 ล้านบาทขึ้นไป จนถึงมากกว่า 10 ล้านบาทเลยก็มี
											</p>
											<p class="mt-2 mb-0">
												<b>คอนโดชลบุรีในโซนสัตหีบ-บางละมุง</b>
											</p>
											<p class="mb-0">
												เป็น 2 อำเภอที่อยู่ใกล้กัน และเป็นแหล่งท่องเที่ยวเชิงธรรมชาติที่มีความสงบมากกว่าย่านศรีราชา-พัทยา-ตัวเมืองชลบุรี คอนโดส่วนใหญ่จึงมีไว้เพื่อการพักผ่อน ทำให้มีราคาที่หลากหลาย เริ่มต้นตั้งแต่ไม่ถึงล้าน ไปจนถึงราคาไม่เกิน 3-4 ล้านบาทเลยทีเดียว
											</p>
											<p class="mt-2 mb-0">
												<b>คอนโดชลบุรีในโซนบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง</b>
											</p>
											<p>
												ส่วนใหญ่โซนนี้จะเป็นพื้นที่เกษตรกรรม ผสมกับแหล่งที่อยู่อาศัยไปจนถึงมีแหล่งงานบ้างประปราย ทำให้ราคาอสังหาฯ ในย่านนี้ไม่แพงมากนัก อยู่ในเรตราคาที่จับต้องได้ง่าย ซึ่งส่วนใหญ่จะเป็นประเภทบ้านเดี่ยว ทาวน์โฮม ทาวน์เฮ้าส์ สำหรับคอนโดจะพบได้บ้างโดยมีให้เลือกซื้อหลายเรตราคา ทั้งราคาไม่เกิน 3 แสน ราคาไม่เกิน 1 ล้านบาท ราคาไม่เกิน 2 ล้านบาทก็มี (ขึ้นอยู่กับพื้นที่และขนาด)
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกคอนโดในจังหวัดชลบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้อคอนโดชลบุรี
								</h3>
								<p class="mt-2 mb-0">
									ในการเลือกซื้อคอนโดชลบุรี ไม่ว่าจะเป็นคอนโดมือสองชลบุรี คอนโดศรีราชาติดทะเล คอนโดใกล้เซ็นทรัลชลบุรี คอนโดเมืองชลบุรี จะต้องพิจารณา 3 ปัจจัยที่สำคัญ ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>1. พื้นที่ตั้งของคอนโดมิเนียมชลบุรี</b>
											</p>
											<p class="mb-0">
												เนื่องจากคอนโดในชลบุรีมีกระจายตัวอยู่ในหลายทำเลด้วยกัน จึงควรเข้าใจก่อนว่า การเลือกซื้อ-ขายคอนโดชลบุรีในทำเลไหนเป็นอย่างไร เช่น
											</p>
											<ul class="ml-10">
												<li>คอนโดศรีราชา จะเป็นทำเลของเมืองท่าและโรงงานอุตสาหกรรมเป็นหลัก แต่ก็มีความเป็นเมืองท่องเที่ยวรวมอยู่ด้วยจากการเป็นเมืองที่ขึ้นชื่อว่า Little Osaka และมีเกาะสีชังอยู่ในทำเล จึงเหมาะกับการซื้อไว้อยู่อาศัยใกล้กับที่ทำงาน หรือจะซื้อไว้ปล่อยเช่าก็ได้ดำไรดีจาก Expat ชาวญี่ปุ่นที่มักเข้ามาทำงานในโรงงานย่านนี้</li>
												<li>คอนโดพัทยา จะเป็นย่านท่องเที่ยว สถานบันเทิงต่างๆ เป็นเมืองท่าข้ามไปยังเกาะล้านได้ ทำให้มีราคาคอนโดชลบุรีในย่านนี้มีราคาสูง แต่ก็เหมาะจะซื้อไว้เป็นที่พักตากสำหรับคนที่ชอบความคึกคักของเมืองท่องเที่ยวเป็นพิเศษ หรือซื้อไว้เก็งกำไรสำหรับปล่อยเช่า-ขายต่อ เนื่องจากเป็นทำเลฮอตของชลบุรี</li>
												<li>คอนโดสัตหีบ เป็นทำเลทองที่นักลงทุนต้องการสูง เพราะมีสถานที่ท่องเที่ยวหลากหลาย  มีถนนเชื่อมต่อหลายสาย พัทยา ชลบุรี และมอเตอร์เวย์สร้างความสะดวกสบายเหมาะสำหรับทุกครอบครัวได้เป็นอย่างดี จึงเหมาะกับการซื้ออยู่อาศัยและลงทุนเป็นอย่างมาก</li>
												<li>คอนโดบางละมุง เป็นอีกหนึ่งทำเลที่อยู่อาศัยของจังหวัดชลบุรี ส่วนใหญ่คนมักซื้อเป็นบ้านพักอากาศหรือปล่อยเช่ารายวันสำหรับนักท่องเที่ยวเนื่องจากมีความสวยงามและเงียบสงบ อีกทั้งเป็นทำเลที่อยู่ระหว่างสัตหีบและศรีราชา ทำให้เป็นที่อยู่อาศัยของคนทำงานในชลบุรีอีกด้วย</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>2. ลักษณะการคมนาคม</b>
											</p>
											<p class="mb-0">
												การคมนาคมในจังหวัดชลบุรี ถือได้ว่าสะดวกไม่แพ้ในกรุงเทพมหานครเลย เนื่องจากมีการพัฒนาพื้นที่เพื่อรองรับการเป็นเมือง EEC ทำให้มีการพัฒนาเรื่องการเดินทางให้สะดวกสำหรับการขนส่งและการเดินทางท่องเที่ยว โดยในโซนยอดนิยม เช่น พัทยา บางละมุง บ่อวิน สัตหีบ ศรีราชา ตัวเมืองชลบุรี จะสามารถเดินทางเข้า-ออกเมืองได้สะดวกด้วยถนนสุขุมวิทที่มุ่งหน้าขึ้นทางพิเศษบูรพาวิถี ก็จะเข้าสู่กรุงเทพมหานครได้เลย ส่วนอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึงที่เป็นพื้นที่เกษตรกรรมส่วนใหญ่ ก็จะมีถนนที่เชื่อมต่อมายังถนนหลักได้ง่าย นอกจากนี้ยังมีโครงการสร้างรถไฟความเร็วสู่ง เพื่อเชื่อม 3 สนามบิน จากดอนเมือง-สุวรรณภูมิ-อู่ตะเภา จึงไม่ต้องกังวลเรื่องการเดินทางเลย
											</p>
											<p class="mt-2 mb-0">
												<b>3. ศักยภาพทำเล</b>
											</p>
											<p>
												ในด้านศักยภาพทำเลเอง ในช่วงอำเภอที่เป็นย่านโรงงานอุตสาหกรรมและเมืองท่องเที่ยว เรียกได้ว่า เตรียมตัวรับความเจริญถึงขีดสุด เพราะในจังหวัดชลบุรีจะมีโปรเจกต์โครงสร้างพื้นฐานคมนาคมผลักดันชลบุรีสู่เขตเศรษฐกิจพิเศษ โดยปัจจุบันมีการพัฒนาสนามบินอู่ตะเภา โครงการพัฒนาท่าเรือสัตหีบ (จุกเสม็ด) โครงการพัฒนาท่าเรือแหลมฉบัง เป็นต้น
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'shophouse'">
							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคา ซื้อ-ขายอาคารพาณิชย์ชลบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									ที่ตั้งของอาคารพาณิชย์ชลบุรีจะมีปัจจัยสำคัญทางด้านราคาอยู่ที่ทำเลที่ตั้งเป็นส่วนใหญ่ ซึ่งเราสามารถแบ่งพื้นที่ชลบุรีออกตามการพัฒนาพื้นที่ได้ 3 ประเภทดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>พื้นที่เกษตรกรรม</b> เป็นทำเลที่เหมาะแก่การเพาะปลูกเป็นหลัก ดังนั้น พื้นที่ส่วนใหญ่จึงเป็นการปลูกสวน ทำการเกษตรและปศุสัตว์ ครอบคลุมพื้นที่อำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง การซื้อ-ขายอาคารพาณิชย์ชลบุรีในพื้นที่นี้จึงเป็นตึกแถวริมถนนเสียส่วนมาก เพื่อให้ทำการค้าในอาคารพาณิชย์ชลบุรีได้อย่างสะดวกมากขึ้น หรือการอยู่ในตัวเมืองที่ค่อนข้างคึกคัก โดยอาคารพาณิชย์ชลบุรีในพื้นที่นี้จะมีราคาเริ่มต้นอยู่ที่ 2 ล้านบาท ส่วนใหญ่จะเป็นอาคารพาณิชย์ 3 ชั้น และราคาจะเปลี่ยนแปลงขึ้นอยู่กับทำเลที่ตั้ง สภาพอาคารและจำนวนคูหาที่ประกาศขาย
											</p>
											<p class="mt-2 mb-0">
												<b>พื้นที่อุตสาหกรรม</b> ด้วยชลบุรีมีการพัฒนานิคมอุตสาหกรรมอยู่มากมาย อีกทั้งยังเป็นพื้นที่ที่มี Expat เข้ามาอยู่อาศัยค่อนข้างมาก ทำให้อาคารพาณิชย์ชลบุรี ในพื้นที่นี้มีราคาค่อนข้างสูงขึ้นกว่าพื้นที่ทำการเกษตร โดยส่วนมากจะอยู่ในพื้นที่อำเภอพานทอง ศรีราชาและเมืองชลบุรี ซึ่งในโซนเหล่านี้มีนิคมอุตสาหกรรมที่เราคุ้นหูอย่างเช่น นิคมอุตสาหกรรมแหลมฉบังในศีราชา นิคมอุตสาหกรรมอมตะนครในเมืองชลบุรี เป็นต้น ซึ่งอาคารพาณิชย์ชลบุรีในพื้นที่นี้จะมีราคาเริ่มต้นอยู่ที่ 2 ล้านบาทโดยส่วนใหญ่จะเป็นตึกแถวริมถนน
											</p>
											<p class="mt-2 mb-0">
												<b>พื้นที่ท่องเที่ยว</b> อีกส่วนหนึ่งที่นับเป็นเสน่ห์ของชลบุรีคือ การเป็นเมืองท่องเที่ยว จึงทำให้ราคาอสังหาฯ ต่างๆ ได้รับการพัฒนาค่อนข้างมาก ไม่เว้นแม้แต่อาคารพาณิชย์ชลบุรีที่จะปรับตัวสูงขึ้นกว่าพื้นที่อื่นๆ ในจังหวัด โดยจะโดดเด่นในพื้นที่อำเภอบางละมุง พัทยาและสัตหีบ ซึ่งจะมีราคาอาคารพาณิชย์ชลบุรีเริ่มต้นที่ 2 ล้านบาท และถ้าหากเป็นตึกแถวทำเลค้าขายอาจขึ้นไปถึง 20 ล้านบาทได้เลยทีเดียว
											</p>
											<p class="mt-2">
												นอกจากนี้บางพื้นที่ในชลบุรีจะมีลักษณะของทำเลที่ผสมผสานทั้ง 3 รูปแบบเข้าด้วยกัน เช่น ในอำเภอศรีราชาและเมืองชลบุรี ซึ่งจะมีทั้งนิคมอุตสาหกรรมและการท่องเที่ยวอยู่ด้วยกัน ทำให้ราคาอาคารพาณิชย์ชลบุรีของ 2 พื้นที่นี้มีราคาค่อนข้างสูง โดยจะเริ่มตั้งแต่ 3 ล้านบาทขึ้นไป
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอาคารพาณิชย์ในชลบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้ออาคารพาณิชย์ชลบุรี
								</h3>
								<p class="mt-2 mb-0">
									ในการเลือกซื้อทำเลอาคารพาณิชย์ชลบุรีนั้นไม่ว่าจะเป็นอาคารพาณิชย์ศรีราชา อาคารพาณิชย์บ้านบึงหรืออาคารพาณิชย์พัทยา ต่างก็มีปัจจัยที่ต้องพิจารณา 3 ปัจจัยด้วยกัน ดังนี้
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>1. ศักยภาพทำเล</b>
											</p>
											<p class="mb-0">
												การเลือกซื้ออาคารพาณิชย์ชลบุรีนั้นไม่ว่าจะเป็นการเลือกซื้อเพื่อทำการค้าหรือการเก็งกำไรในอาคารพาณิชย์อย่างการปล่อยเช่า ล้วนแต่ต้องดูการพัฒนาพื้นที่ในระยะยาว ซึ่งชลบุรีนับเป็นพื้นที่ EEC ซึ่งจะมีการพัฒนาอย่างมากในอนาคต ทำให้การตรวจสอบดูศักยภาพทำเลเป็นเรื่องสำคัญมากเช่นกัน โดยชลบุรีมีการพัฒนาทำเลที่น่าสนใจในหลายๆ ด้าน ดังนี้
											</p>
											<ul class="ml-10">
												<li><b>พื้นที่ท่องเที่ยว</b> ในจังหวัดชลบุรีอย่างอำเภอบางละมุงซึ่งมีเขตพิเศษอย่างพัทยา, Little Osaka อย่างศรีราชา หรือสัตหีบ ซึ่งเป็นทำเลที่มีการพัฒนาให้สามารถรองรับการเข้ามาท่องเที่ยวได้มากขึ้น ทั้งแบบระยะสั้นและระยะยาว สำหรับใครที่มองหาบ้านหลังสองและระยะสั้นจะส่งผลต่อการค้าขายของอาคารพาณิชย์ชลบุรีในพื้นที่ค่อนข้างมาก เพราะเป็นการผลัดเปลี่ยน หมุนเวียนผู้คนให้เข้ามาจับจ่ายใช้สอยในทำเล ทำให้มีแนวโน้มว่าอาคารพาณิชย์ชลบุรีในพื้นที่จะมีราคาสูงขึ้น จึงเหมาะสำหรับการเก็งกำไรหรือการปล่อยเช่าเก็บกำไรด้วยเช่นกัน</li>
												<li><b>พื้นที่อุตสาหกรรม</b> ภายในพื้นที่นี้จะมีการแทรกตัวของพื้นที่อยู่อาศัยมากขึ้น เพราะผู้พัฒนาต้องการตอบโจทย์ความสะดวกสบายให้กับผู้อยู่อาศัย ทำให้การค้าขายในพื้นที่จะคึกคักมากขึ้นในอนาคต อย่างในพื้นที่นิคมอุตสาหกรรมอมตะนครในเมืองชลบุรีหรือนิคมอุตสาหกรรมแหลมฉบังในศรีราชาที่จะมีผู้คนอาศัยอยู่ค่อนข้างมาก จึงเหมาะสำหรับการทำอาคารพาณิชย์ชลบุรีเพื่อการค้าขายเกี่ยวกับอาหาร ของใช้ในบ้านหรือร้านสะดวกซื้อเป็นอย่างมาก</li>
												<li><b>พื้นที่เกษตรกรรม</b> เป็นทำเลที่ค่อนข้างเงียบสงบในชลบุรี ทำให้อาคารพาณิชย์ในพื้นที่ส่วนใหญ่มักเป็นตึกแถวริมถนนมากกว่าในเขตชุมชน และการพัฒนาในพื้นที่มักจะเป็นไปอย่างช้าๆ ทำให้การเลือกพื้นที่เกษตรกรรมอย่างอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึงนั้นไม่ค่อยเป็นที่นิยมเท่าใดนักสำหรับการลงทุนซื้อตึกแถว แต่สามารถเลือกซื้อไว้เพื่อการค้าขายสำหรับคนในพื้นที่ได้ หรือซื้อไว้เพื่อรอการพัฒนาในอนาคตก็มีแนวโน้มที่ดีเช่นเดียวกัน</li>
											</ul>
											<p class="mt-2 mb-0">
												<b>2. การคมนาคม</b>
											</p>
											<p class="mb-0">
												การเดินทางในชลบุรีนั้นนับว่าสะดวกสบายอย่างมากทีเดียว เพราะด้วยการพัฒนาพื้นที่มีค่อนข้างมากเพื่อรองรับการเป็นเมือง EEC ทำให้การเดินทางขนส่งและการเดินทางท่องเที่ยวค่อนข้างสะดวก โดยเฉพาะในอนาคตที่จะมีการสร้างรถไฟความเร็วสูงซึ่งมีสถานีมากมายในชลบุรีทำให้การเลือกซื้ออาคารพาณิชย์ชลบุรีมีความคึกคักมากขึ้น โดยเฉพาะตามแนวเส้นถนนสุขุมวิทซึ่งจะกลายเป็นที่ตั้งของสถานีรถไฟมากมายในอนาคตนั่นเอง
											</p>
											<p class="mt-2 mb-0">
												<b>3. ที่ตั้งของอาคารพาณิชย์ชลบุรี</b>
											</p>
											<p class="mb-0">
												สำหรับการเลือกซื้ออาคารพาณิชย์ชลบุรีนั้นยังสามารถพิจารณาจากที่ตั้งของอาคารพาณิชย์ได้ด้วยเช่นกัน นอกจากความแตกต่างทางลักษณะพื้นที่แล้ว ความแตกต่างของรูปแบบที่ตั้งก็ส่งผลต่อราคาอาคารพาณิชย์และความเหมาะสมในการใช้งานเช่นกัน ไม่ว่าจะเป็น…
											</p>
											<ul class="ml-10">
												<li><b>การเลือกซื้อตึกแถวริมถนน</b> โดยส่วนใหญ่แล้วตึกแถวริมถนนหรืออาคารพาณิชย์ชลบุรีริมถนน จะเหมาะสำหรับร้านค้าที่ต้องใช้เวลาในการใช้บริการ เช่น ร้านอาหาร ร้านอุปกรณ์เครื่องเขียน ร้านแว่นตา เป็นต้น โดยจะให้ความสะดวกในการใช้บริการอย่างเป็นส่วนตัว ไม่อึดอัด</li>
												<li><b>การเลือกซื้อตึกแถวทำเลค้าขาย</b> ตึกแถวหรืออาคารพาณิชย์ชลบุรีในที่ตั้งนี้จะมีคนเข้า-ออกค่อนข้างมาก เพราะตั้งอยู่ในพื้นที่คึกคัก ส่วนใหญ่จะเป็นร้านค้าที่ใช้เวลาไม่นาน เช่น ร้านขายของชำ อาหารแห้ง ร้านขายของฝาก เป็นต้น ซึ่งตึกแถวทำเลค้าขายสามารถนำมาเก็งกำไรด้วยการขายต่อก็ได้ แต่ก็เหมาะสมสำหรับการอยู่อาศัยเช่นกัน</li>
											</ul>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'search'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'

export default {
	// scrollToTop: true,
	name: 'LIST',
	layout: 'default_2',

	components: {
		searchForm,
		propertyListItem,
		propertyListItemSkeleton
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let params = context.params
		let content = params.area || params.category || null
		let query = {}
		let widgetQuery = {}

		// const market_selected = params.category === 'singlehome' ? 'HOME' : params.category === 'townhome' ? 'TOWNHOUSE' : params.category === 'condo' ? 'CONDO' : 'COMMERCIAL_BUILDING'

		// Category
		const province = 11
		if (content === 'singlehome') {
			data['title'] = 'รวมอสังหาฯ ซื้อ ขาย บ้านเดี่ยวชลบุรี บ้านเดี่ยวมือสองชลบุรี ราคาถูก 2565'
			data['description'] = 'รวมอสังหาฯ ซื้อ ขาย บ้านเดี่ยวชลบุรี บ้านเดี่ยวมือสองชลบุรี ราคาถูก 2565 ศรีราชา บ่อวิน พัทยา บางแสน พร้อมรายละเอียดข้อมูล ราคา'

			query = widgetQuery = {
				province,
				market_selected: 'HOME'
			}
		}
		else if (content === 'townhome') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ ทาวน์โฮมชลบุรี ทาวน์เฮ้าส์ชลบุรี มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ บ้านทาวน์โฮมชลบุรี ทาวน์เฮ้าส์ชลบุรี Townhome Townhouse มือสอง ราคาถูก พร้อมอยู่ พัทยา ศรีราชา บางแสน'

			query = widgetQuery = {
				province,
				market_selected: 'TOWNHOUSE'
			}
		}
		else if (content === 'condo') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดชลบุรี คอนโดมิเนียมชลบุรี มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดชลบุรี คอนโดมิเนียมชลบุรี มือสอง Condo ราคาถูก เมืองชลบุรี ศรีราชา และอื่นๆ พร้อมรายละเอียดราคา ข้อมูล'

			query = widgetQuery = {
				province,
				market_selected: 'CONDO'
			}
		}
		else if (content === 'shophouse') {
			data['title'] = 'รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์ชลบุรี ตึกแถว มือสอง ราคาถูก'
			data['description'] = 'รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์ชลบุรี ตึกแถว บ้านตึก มือสอง ทำเลดี ราคาถูก เมืองชลบุรี ศรีราชา พัทยา บ้านบึง บางแสน พร้อมข้อมูล'

			query = widgetQuery = {
				province,
				market_selected: 'COMMERCIAL_BUILDING'
			}
		}

		widgetQuery = { ...query }

		await context.store.dispatch('page/initial', data)

		return {
			params, content, query, widgetQuery,
			areaSelected: params.area,
			location: 'ชลบุรี',
			locationName: 'chonburi',
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		empty: false,
		perPage: 12,
		propertyList: [],
		queryTxt: '',
		page: 1,
		total: 0,
	}),

	computed: {
		...mapGetters({
			getProperty: 'property/getProperty',
			head: 'page/head',
		}),

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},

		category () {
			if (this.content || this.content && ['singlehome','townhome','condo', 'shophouse'].includes(this.content)) {
				return [
					{ text: 'บ้านเดี่ยว', path: `/${this.locationName}/singlehome` },
					{ text: 'ทาวน์โฮม', path:  `/${this.locationName}/townhome` },
					{ text: 'คอนโด', path:  `/${this.locationName}/condo` },
					{ text: 'อาคารพาณิชย์', path:  `/${this.locationName}/shophouse` },
				]
			}

			return null
		},

		area () {
			if (this.content && [
				'singlehome', // 'townhome','condo', 'shophouse',
			].includes(this.content)) {
				return null
			}

			return null
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},
	},

	watch: {
		page (newPage) {
			// this.$refs.top.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' })
			this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'end' })

			this.query.page = newPage
			this.search()
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			this.search()
		}
	},

	created() {
		if (process.client) {
			this.search()
		}
	},

	mounted() {

	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		search () {
			// if (this.loading) return
			this.loading = true
			this.propertyList = []
			this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = {
				...this.query,
				ipp: this.perPage // item per page
			}

			this.$nextTick(() => {
				// window.scrollTo(0, 0)
				this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'end' })
			})

			this.searchProperty(params).then(propObj => {
				this.propertyList = propObj.propsList
				this.total = propObj.total
				this.queryTxt = propObj.queryTxt
				this.perPage = propObj.perPage

				this.empty = this.propertyList.length === 0
				this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	padding: 32px 0 60px 0;

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgba(157,30,37,1);
	}

	.category-menu {
		position: relative;

		&::before {
			content: ' ';
			position: absolute;
			background: #fff;
			left: -24px;
			right: 0;
			top: -32px;
			bottom: -60px;
		}
		&::after {
			content: ' ';
			position: absolute;
			z-index: 0;
			width: 150vw;
			left: -84px;
			top: 0;
			bottom: 0;
			background: rgb(237,28,36);
		}

		& > div {
			position: relative;
			z-index: 1;
		}
	}
}
.area:hover, .area.v-btn--active {
	background-color: #3a3a3a;
	color: #fff;
}
.widget-btn .v-btn:hover {
	background-color: rgb(237,28,36);
	color: #fff;
	border-color: rgb(237,28,36);
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	p {
		text-indent: 30px;
	}

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
